import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { clsx } from 'clsx';

type Variant = 'primary' | 'secondary';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  /** Help element id (ADR-0066) — rendered as {@code data-help-id}. */
  helpId?: string | undefined;
};

export const Button = forwardRef<HTMLButtonElement, Props>(function Button(
  { variant = 'primary', className, helpId, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      data-help-id={helpId}
      className={clsx(
        'inline-flex items-center justify-center rounded px-3 py-1.5 text-sm font-medium transition disabled:cursor-not-allowed disabled:opacity-50',
        variant === 'primary' && 'bg-phblue-600 text-white hover:bg-phblue-700',
        variant === 'secondary' && 'border border-slate-300 bg-white text-slate-800 hover:bg-slate-50',
        className,
      )}
      {...rest}
    />
  );
});
